
import { Component, Vue } from "vue-property-decorator";
const AppBar = () => import("@/components/core/AppBar.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");

@Component({
  components: {
    AppBar,
    AppFooter,
  },
})
export default class Home extends Vue {
  // VARS --- COMPONENTS
  private numberSelected = 0;

  created(): void {
    window.location.href = "http://bracchiruote.it";
  }
}
